import { Theme } from '@mui/material';
/**
 * CcfCustomerCard - used to display quick replies component
 * @param props -?-customerCardDetailsStyles
 * @example <customerCardDetailsStyles />
 */
const CcfRtigAccordionStyles = (theme: Theme) => {
  const simStyles = {
  
    accordionContainer: {
      boxShadow: 'none',
      display: 'block',
    },
  
    accordionHeaderExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: '0px -1px 1px #e7eaec',
    },
    accordionHeader: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
    },
    accordionHeaderActivityExpand: {
      flexDirection: 'row-reverse',
      paddingLeft: '10px',
      borderTop: `solid ${theme.palette.background.default} 1px`,
      boxShadow: `-1px 1px 1px #fdeeef`,
    },
   
    expandedIcon: {
      transform: 'rotate(180deg)',
      height: '20px',
      width: '20px',
      color: `#5B7C8C`,
    },
   
    hideAccordion: {
      display: 'none',
    },
    mergeIcon: {
      position: 'absolute',
      right: theme.spacing(1),
    },
   
    notesAccordionTitle:{
      fontWeight: '600',
    },
  };
  return simStyles;
};
export default CcfRtigAccordionStyles;